import Immutable from 'immutable';

export const sum = <K extends number | string>(collection: Immutable.Collection<K, number> | number[]): number => (
  (collection as number[]).reduce((summ, value) => summ + value, 0)
);
